<template>
  <div class="reproductor-container">

    <div class="music-wrapper">
      <!-- Añadido el atributo loop para repetir la canción automáticamente -->
      <audio
        ref="audio"
        :src="songSource"
        preload="auto"
        loop
        @timeupdate="updateProgress"
        @ended="resetPlayer"
      />

      <button @click="togglePlay" class="play-button">
        <i :class="isPlaying ? 'fas fa-pause' : 'fas fa-play'"></i>
      </button>

      <span class="time">{{ currentTime }}</span>

      <input
        type="range"
        class="progress-bar"
        min="0"
        max="100"
        step="0.1"
        :value="progress"
        @input="seekMusic"
      />

      <span class="time">{{ duration }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      songSource: require('@/assets/musicafondo1.mp3'),
      isPlaying: false,
      progress: 0,
      currentTime: '00:00',
      duration: '00:00'
    };
  },
  mounted() {
    const audio = this.$refs.audio;

    // Establecer duración cuando esté listo
    audio.onloadedmetadata = () => {
      this.duration = this.formatTime(audio.duration);
    };

    // 1. Intento inmediato de reproducción normal
    this.intentarReproducir();

    // 2. Disparadores globales ante cualquier interacción táctil, scroll o movimiento
    const activarAudioGlobal = () => {
      if (!this.isPlaying) {
        this.intentarReproducir();
      }
      // Una vez que se logra interactuar, removemos los listeners para optimizar memoria
      if (this.isPlaying) {
        removerListeners();
      }
    };

    const removerListeners = () => {
      document.removeEventListener('touchstart', activarAudioGlobal, { passive: true });
      document.removeEventListener('touchmove', activarAudioGlobal, { passive: true });
      document.removeEventListener('scroll', activarAudioGlobal, { passive: true });
      document.removeEventListener('click', activarAudioGlobal);
    };

    // Escuchadores de eventos para el más mínimo movimiento o touch
    document.addEventListener('touchstart', activarAudioGlobal, { passive: true });
    document.addEventListener('touchmove', activarAudioGlobal, { passive: true });
    document.addEventListener('scroll', activarAudioGlobal, { passive: true });
    document.addEventListener('click', activarAudioGlobal);

    // Guardar referencia para poder removerlos en el unmounted
    this._removerAudioListeners = removerListeners;
  },
  beforeUnmount() {
    // Limpieza de eventos al destruir el componente
    if (this._removerAudioListeners) {
      this._removerAudioListeners();
    }
  },
  methods: {
    intentarReproducir() {
      const audio = this.$refs.audio;
      if (!audio) return;

      audio.play()
        .then(() => {
          this.isPlaying = true;
          if (this._removerAudioListeners) this._removerAudioListeners();
        })
        .catch((err) => {
          console.warn('Autoplay esperando interacción del usuario o touch.', err);
        });
    },
    togglePlay() {
      const audio = this.$refs.audio;
      if (this.isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
      this.isPlaying = !this.isPlaying;
    },
    updateProgress() {
      const audio = this.$refs.audio;
      if (!audio.duration) return;
      this.progress = (audio.currentTime / audio.duration) * 100;
      this.currentTime = this.formatTime(audio.currentTime);
    },
    seekMusic(event) {
      const audio = this.$refs.audio;
      const newTime = (event.target.value / 100) * audio.duration;
      audio.currentTime = newTime;
    },
    resetPlayer() {
      // Nota: Al usar 'loop', 'ended' rara vez se dispara, pero mantiene el estado seguro.
      this.isPlaying = false;
      this.progress = 0;
      this.currentTime = '00:00';
    },
    formatTime(time) {
      if (isNaN(time)) return '00:00';
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
  }
};
</script>

<style scoped>
.reproductor-container {
  position: relative;
  width: 100%;
  margin-top: 20px;
  background-image: url('@/assets/7.png');
  background-size: cover;
}

.texto-reproductor {
  text-align: center;
  font-family: 'padres';
  font-size: 14px;
  background-color: rgba(255, 255, 255, 0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  letter-spacing: 6px;
  text-transform: uppercase;
  color: #555;
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 20px;
}

.music-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 10px;
}

.play-button {
  background-color: rgba(161, 151, 142, 0.95);
  color: white;
  border: none;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
}

.play-button i {
  pointer-events: none;
}

.progress-bar {
  flex-grow: 1;
  height: 6px;
  border-radius: 4px;
  background: #ddd;
  appearance: none;
  outline: none;
}

.time {
  font-family: 'padres';
  font-size: 13px;
  color: #333;
}
</style>